module.exports = __webpack_public_path__ + "static/img/login.c133fdea.png";